module.exports = __webpack_public_path__ + "img/sdEmpty.png";